import { memo, type ReactNode, type FunctionComponent } from 'react';
// Material UI imports
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
// SCSS imports
import { overlayDefault } from '../styles/modules/Overlay.module.scss';

type ReloadingOverlayProps = {
  readonly children: ReactNode;
  readonly reloading?: boolean | null;
};

const ReloadingOverlay: FunctionComponent<ReloadingOverlayProps> = ({
  children,
  reloading
}) => reloading ? (
  <Box
      flexGrow={1}
      display="flex"
      flexDirection="column"
      position="relative"
  >
    {children}
    <Box className={overlayDefault}>
      <LinearProgress/>
    </Box>
  </Box>
) : children;

export default memo(ReloadingOverlay);
